// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"4bc790fb","230":"e5c92cd9","241":"761c78fb","295":"d0b09cff","335":"7e27cf14","338":"81bc98d4","370":"a0fdf115","453":"62b2bff0","580":"605a0235","654":"4664de23","685":"bc08e3da","689":"f0c2ce32","742":"75ded83d","778":"058e8250"}[chunkId] + ".chunk.js";
};